import React from 'react';
import styled from '@emotion/styled';

import { ProductAboveAtfBadgeList } from '@domains/pdp-common';

interface BadgeProps {
  badgeList: ProductAboveAtfBadgeList[] | null;
}

export const BadgeList: React.FC<React.PropsWithChildren<BadgeProps>> = ({ badgeList }) => {
  return (
    <Wrap>
      {badgeList?.map(({ image_url }, index) => (
        <Badge key={image_url}>
          <BadgeImage key={index} src={image_url} alt='뱃지 이미지' />
        </Badge>
      ))}
    </Wrap>
  );
};

const Wrap = styled.div`
  position: relative;
  margin: 0 0 10px 0;
  padding: 0 16px;
  display: flex;
  row-gap: 8px;
  flex-wrap: wrap;

  img,
  svg {
    margin: 0 4px 0 0;
  }
`;

const Badge = styled.div`
  position: relative;
`;

const BadgeImage = styled.img`
  width: auto;
  height: 24px;
`;
